(function () {
  var preloader = document.querySelector('[data-preloader]');

  if (!preloader) {
    return;
  }

  var minVisibleTime = 1800;
  var startedAt = Date.now();
  var glitchTimer = null;
  var removeTimer = null;

  function runGlitch() {
    if (!document.body.contains(preloader) || preloader.classList.contains('is-leaving')) {
      return;
    }

    preloader.classList.add('is-glitching');

    window.setTimeout(function () {
      preloader.classList.remove('is-glitching');
      scheduleGlitch();
    }, 180 + Math.random() * 320);
  }

  function scheduleGlitch() {
    var nextGlitch = 2000 + Math.random() * 2000;
    glitchTimer = window.setTimeout(runGlitch, nextGlitch);
  }

  function hidePreloader() {
    var elapsed = Date.now() - startedAt;
    var delay = Math.max(0, minVisibleTime - elapsed);

    window.setTimeout(function () {
      window.clearTimeout(glitchTimer);
      preloader.classList.add('is-leaving');

      removeTimer = window.setTimeout(function () {
        if (preloader && preloader.parentNode) {
          preloader.parentNode.removeChild(preloader);
        }
      }, 700);
    }, delay);
  }

  scheduleGlitch();

  if (document.readyState === 'complete') {
    hidePreloader();
  } else {
    window.addEventListener('load', hidePreloader, { once: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.clearTimeout(glitchTimer);
      window.clearTimeout(removeTimer);
      if (preloader && preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }
  });
})();
